<div
  class="job-item"
  [class.abortable]="job?.state === JobState.Running && job?.abortable"
  [class.interactive]="clickable"
  [matTooltip]="job?.state === JobState.Failed ? job.error : null"
  [matTooltipPosition]="'left'"
>
  <div class="job-item-body" (click)="clickable && open()">
    <div fxLayout="row" fxLayoutAlign="space-between baseline" fxLayoutGap="8px">
      <span class="job-description">
        {{ job.description ? job.description : job.method }}
      </span>
      <small *ngIf="job.state === JobState.Running" class="job-progress-percent">
        {{ job.progress.percent || 0 | number: '1.2-2' }}%
      </small>
    </div>

    <mat-progress-bar
      *ngIf="job.state === JobState.Running"
      class="job-progress"
      [value]="job.progress.percent"
      [mode]="job.progress.percent ? 'determinate' : 'indeterminate'"
    ></mat-progress-bar>

    <div [ngSwitch]="job.state">
      <ng-container *ngSwitchCase="JobState.Running">
        <div *ngIf="job?.progress?.description" class="job-progress-description">
          {{ job.progress.description }}
        </div>
        <div *ngIf="!job?.progress?.description" class="job-time">
          {{ 'Started' | translate }}:
          <strong>
            {{ job.time_started?.$date ? (job.time_started.$date | formatDateTime) : '–' }}
          </strong>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="JobState.Waiting">
        <div class="job-time">
          {{ 'Waiting' | translate }}:
          <strong>
            {{ job.time_started?.$date ? (job.time_started.$date | formatDateTime) : '–' }}
          </strong>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="JobState.Failed">
        <div class="job-time">
          {{ 'Stopped' | translate }}:
          <strong>
            {{ job.time_finished?.$date ? (job.time_finished.$date | formatDateTime) : '–' }}
          </strong>
        </div>
      </ng-container>
    </div>

    <div *ngIf="job.credentials">
      <div class="job-credentials">
        {{
          'Created by: {creationSource} ({creationType})' | translate: {
            creationSource: getCredentialsCreationSource(job.credentials),
            creationType: (job.credentials.type | mapValue: credentialTypeLabels | translate)
          }
        }}
      </div>
    </div>
  </div>

  <button
    *ngIf="job.state === JobState.Running && job.abortable"
    class="job-button-abort"
    mat-icon-button
    type="button"
    [ixTest]="['abort', job.description, job.method]"
    [matTooltip]="'Abort' | translate"
    (click)="abort()"
  >
    <ix-icon name="mdi-stop-circle" class="job-icon-abort"></ix-icon>
  </button>

  <button
    *ngIf="job.state === JobState.Waiting"
    mat-icon-button
    type="button"
    [ixTest]="['waiting', job.description, job.method]"
    [disabled]="true"
  >
    <ix-icon name="schedule" class="job-icon-waiting"></ix-icon>
  </button>

  <button
    *ngIf="job.state === JobState.Failed"
    mat-icon-button
    type="button"
    [ixTest]="['failed', job.description, job.method]"
    [disabled]="true"
  >
    <ix-icon
      name="cancel"
      matTooltipPosition="left"
      class="job-icon-failed"
      [matTooltip]="job.error"
    ></ix-icon>
  </button>

  <button
    *ngIf="job.state === JobState.Success"
    mat-icon-button
    type="button"
    [ixTest]="['success', job.description, job.method]"
    [disabled]="true"
  >
    <ix-icon name="mdi-check-circle" class="job-icon-success"></ix-icon>
  </button>
</div>
